/* Tuki: mirror the selected Pumper tier; Shopify remains the source of checkout prices. */
(() => {
  function parseMoney(text) {
    let value = String(text || '').replace(/[^\d.,-]/g, '');
    if (!value || value.startsWith('-')) return null;
    const separator = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    const decimals = separator >= 0 ? value.length - separator - 1 : 0;
    if (decimals === 1 || decimals === 2) {
      value = value.slice(0, separator).replace(/[.,]/g, '') + '.' + value.slice(separator + 1);
    } else value = value.replace(/[.,]/g, '');
    const amount = Number(value);
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function init(configNode) {
    const config = JSON.parse(configNode.textContent);
    const root = document.getElementById('mt-tuki-' + config.sectionId);
    if (!root || root.dataset.tukiPriceBound) return;
    root.dataset.tukiPriceBound = 'true';
    const formHost = root.querySelector('.mt-tuki__form-host');
    const price = root.querySelector('[data-mt-price]');
    const compare = root.querySelector('[data-mt-compare]');
    const savings = root.querySelector('[data-mt-savings]');
    const installments = root.querySelector('[data-mt-installments]');
    const sticky = root.querySelector('[data-mt-sticky-price]');
    if (!formHost || !price || !compare || !savings) return;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es-UY', {
      style: 'currency', currency: config.currency
    });
    const money = cents => formatter.format(cents / 100);
    let previous = '';
    let frame = 0;
    let animation;

    function update() {
      frame = 0;
      let amount, original, label = '';
      const selected = formHost.querySelector('.pumper_pair:checked, .prvw_pair:checked');
      if (selected) {
        const tier = selected.closest('.pumper_block__cb, .prvw_block__cb');
        if (!tier) return;
        const total = tier.querySelector('[id^="pumper_totalAmount_"], [id^="prvw_totalAmount_"]');
        const was = tier.querySelector('[id^="pumper_originalAmount_"], [id^="prvw_originalAmount_"]');
        amount = parseMoney(total && total.textContent);
        original = parseMoney(was && was.textContent);
        const title = tier.querySelector('[data-tier-title]');
        label = title ? title.textContent.trim() : '';
        // Never guess a bundle discount from its label, quantity or a percentage.
        if (amount === null) return;
        original = original === null ? amount : Math.max(amount, original);
      } else {
        // Wait for the app's selection instead of replacing a bundle with a unit price.
        if (formHost.querySelector('#pumper_bundle_svelte, .prvw_block')) return;
        const variantInput = root.querySelector('[data-mt-variant-id]');
        const variant = config.variants.find(item => String(item.id) === String(variantInput && variantInput.value));
        if (!variant) return;
        const quantityInput = formHost.querySelector('[name="quantity"]');
        const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
        amount = variant.price * quantity;
        original = Math.max(variant.price, variant.compare_at_price || 0) * quantity;
      }
      const signature = [amount, original, label].join(':');
      if (signature === previous) return;
      previous = signature;
      const saved = original - amount;
      price.textContent = money(amount);
      price.setAttribute('aria-label', (label ? 'Total ' + label + ': ' : '') + money(amount));
      compare.textContent = money(original);
      compare.hidden = saved <= 0;
      savings.hidden = saved <= 0;
      savings.textContent = 'Ahorrás ' + money(saved);
      savings.title = 'Ahorro respecto al precio anterior de la opción seleccionada';
      if (installments) installments.textContent = 'Hasta 12 cuotas de ' + money(Math.round(amount / 12));
      if (sticky) sticky.textContent = money(amount);
      if (animation) animation.cancel();
      if (saved > 0 && savings.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        animation = savings.animate([
          { transform: 'translateY(3px) scale(.96)', opacity: .5 },
          { transform: 'translateY(0) scale(1.04)', opacity: 1, offset: .65 },
          { transform: 'translateY(0) scale(1)', opacity: 1 }
        ], { duration: 380, easing: 'ease-out' });
      }
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new MutationObserver(schedule);
    observer.observe(formHost, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['checked', 'value', 'class'] });
    formHost.addEventListener('change', schedule);
    formHost.addEventListener('input', schedule);
    formHost.addEventListener('click', schedule);
    update();
    const unload = event => {
      if (event.detail.sectionId !== config.sectionId) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      if (animation) animation.cancel();
      formHost.removeEventListener('change', schedule);
      formHost.removeEventListener('input', schedule);
      formHost.removeEventListener('click', schedule);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  function scan() { document.querySelectorAll('[data-tuki-price-config]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
